import React from 'react';
import { Alert, Textarea } from '@parsina/framework';

import { useTranslation } from '../../i18n';
import TaskDialog from '../../components/TaskDialog';
import { REASON_MAX, REASON_MIN } from './shared';

/**
 * «آزادسازی اتصال حساب از پرونده» (PM-0546): the record stays, the account that
 * holds it stops holding it — a wrong claim, a claim through a recycled number.
 * The person signs in again and claims their own record. The reason is mandatory
 * (it is the audit line); the server refuses too unless that account still holds
 * the record, so a stale screen cannot release someone else's.
 */
export default function ReleaseDialog({
  target, pending, error, onOpenChange, onSubmit,
}) {
  const { t } = useTranslation();
  const [reason, setReason] = React.useState('');
  const [touched, setTouched] = React.useState(false);

  React.useEffect(() => { setReason(''); setTouched(false); }, [target?.record?.id]);

  const trimmed = reason.trim();
  const invalid = trimmed.length < REASON_MIN;

  return (
    <TaskDialog
      open={!!target}
      onOpenChange={onOpenChange}
      title={t('accounts.release.title', { name: target?.record?.fullName || target?.record?.id || '' })}
      error={error}
      pending={pending}
      dirty={!!reason}
      submitLabel={t('accounts.release.submit')}
      submitVariant="destructive"
      submitDisabled={invalid}
      onSubmit={() => { setTouched(true); if (!invalid) onSubmit({ reason: trimmed }); }}
      data-testid="accounts-release"
      lead={(
        <Alert variant="warning" data-testid="accounts-release-warning">
          {t('accounts.release.warning', { holder: target?.holderLabel || '' })}
        </Alert>
      )}
    >
      <div data-testid="accounts-release-reason">
        <Textarea
          label={t('accounts.release.reason')}
          required
          helperText={t('accounts.release.reasonHelp')}
          value={reason}
          onChange={(e) => setReason(e.target?.value ?? e)}
          onBlur={() => setTouched(true)}
          error={touched && reason && invalid ? t('validation.tooShort', { min: REASON_MIN }) : undefined}
          maxLength={REASON_MAX}
          showCount
          rows={3}
          disabled={pending}
        />
      </div>
    </TaskDialog>
  );
}
